import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function MoreSolid({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-2 -7 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g fill="none" fillRule="evenodd">
        <path
          className={theme.fill}
          d="M25.580148 15.2548c-1.36092 0-2.45916-1.11-2.45916-2.484 0-1.3746667 1.09824-2.484 2.45916-2.484 1.36092 0 2.45982 1.1093333 2.45982 2.484 0 1.374-1.0989 2.484-2.45982 2.484m-7.75632 0c-1.36092 0-2.45982-1.11-2.45982-2.484 0-1.3746667 1.0989-2.484 2.45982-2.484 1.36092 0 2.45916 1.1093333 2.45916 2.484 0 1.374-1.09824 2.484-2.45916 2.484m-7.75698 0c-1.36026 0-2.45916-1.11-2.45916-2.484 0-1.3746667 1.0989-2.484 2.45916-2.484 1.36092 0 2.45916 1.1093333 2.45916 2.484 0 1.374-1.09824 2.484-2.45916 2.484M30.162528.24346667H8.931648c-.97614 0-1.74042.5-2.2506 1.258L.401808 13.1101333 6.681048 24.7048c.51018.758 1.37346 1.2726667 2.35026 1.2726667h21.13122c1.55694 0 2.83074-1.2866667 2.83074-2.8593334V3.10213333c0-1.572-1.2738-2.85866666-2.83074-2.85866666"
        />
      </g>
    </svg>
  )
}

MoreSolid.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
